<template lang="pug">
.number_box
  .logo_box(v-if="data.logo")
    img.logo_img(:src="data.logo")

  h2.questions_title {{ localizedName }}

  .first_number_box(:class="{ 'divide': firstNumArr < 5 }")
    .box(
      v-for="(item, index) in firstNumArr"
      :key="item"
      :class="{ 'selected': selected === index }"
      @click="submit(item)"
    ) {{ item }}

  .last_number_box(:class="{ 'divide': lastNumArr < 5 }")
    .box(
      v-for="(item, index) in lastNumArr"
      :key="item"
      :class="{ 'selected': selected === index + firstNumArr }"
      @click="submit(item + firstNumArr)"
    ) {{ item + firstNumArr }}

  .description {{ tParams('rating_description', 'Where 1 is poor and {max} is excellent', { max: noOfAnswer }) }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getLocalizedCampaignField, t, tParams } from '@/utils/language'

@Component({
  props: {
    index: Number,
    data: Object
  },

  computed: {
    localizedName() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return getLocalizedCampaignField(this.data, 'displayName') || getLocalizedCampaignField(this.data, 'name') || this.data?.name || ''
    },
    // Calculate the number in the first row
    // 计算第一行数字有多少个
    firstNumArr() {
      const num = this.noOfAnswer
      if (num <= 5) {
        return num
      } else if (num % 2) {
        return (num + 1) / 2
      } else {
        return num / 2
      }
    },

    lastNumArr() {
      // Calculate the number in the second row
      // 计算第二行数字有多少个
      const num = this.noOfAnswer
      if (num <= 5) {
        return 0
      } else if (num % 2) {
        return (num - 1) / 2
      } else {
        return num / 2
      }
    },
  }
})

class numberComponents extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  tParams(key, fallback, params) { return tParams(key, fallback, params) }

  selected = null
  noOfAnswer = this.data?.settings?.survey?.noOfAnswer ?? 0

  submit(item) {
    this.selected = item - 1
    this.$emit('event', item) // Expose click events   // 暴露点击事件
  }

  _initializationData() {
    this.selected = null
  }
}

export default numberComponents
</script>

<style lang="sass" scoped>
@use "../style/index" as *

.box
  width: 58px
  height: 57px
  margin-bottom: 17px
  text-align: center
  font-size: 20px
  font-weight: bold
  line-height: 57px
  border: 1px solid #e0e1e2
  border-radius: 5px

  .questions_title
    ont-weight: bold

.description
  font-size: 14px
  text-align: center

.first_number_box, .last_number_box
  display: flex
  justify-content: space-between
  padding: 0 17px 0 15px

.divide
  justify-content: space-around

.middle
  justify-content: center
</style>
